/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { createRoute, Route } from 'framework/routing';
import {
  READ_PAYROLL_DISTRIBUTION,
  PAYROLL_DISTRIBUTION_PATH,
} from 'domain/finance/payroll/payrollDistribution/usePayrollDistributionService';
import PayrollDistributionListPage from 'domain/finance/payroll/payrollDistribution/List';
import { ProtectedRouter } from 'infrastructure/routing';

const usePayrollDistributionRoute = () => {
  return createRoute({ listRoute: PAYROLL_DISTRIBUTION_PATH });
};

const PayrollDistributionRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = usePayrollDistributionRoute();

  return (
    <ProtectedRouter basePath={PAYROLL_DISTRIBUTION_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PAYROLL_DISTRIBUTION}>
              <PayrollDistributionListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PayrollDistributionRouter.getRouterPath = () => PAYROLL_DISTRIBUTION_PATH;

export default PayrollDistributionRouter;
